// i18next-extract-mark-ns-start Services
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import {
  mobileThresholdPixels, colors, frames, margins, tabletThresholdPixels,
} from '../v4/styledComponents';
import contactInfos from '../../../config/contactInfos';

const Container = styled.div`
  margin: ${margins.m6} ${frames.desktop};
  position: relative;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: ${margins.m14} ${frames.tablet};
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 0px ${frames.mobile} 64px;
  }
`;
const Img = styled.img`
  width: 100%;
  @media (max-width: ${mobileThresholdPixels}) {
    height: 501px;
    object-fit: cover;
  }
`;
const TextContainer = styled.div`
  text-align: center;
  width: 680px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  @media (max-width: ${mobileThresholdPixels}) {
    width: 236px;
  }
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 16px;
  }
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 400;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 14px;
  }
`;

const ContactLink = styled.a`
  font-weight: 700;
  color: ${colors.black};
`;

function SpecialRequest({ background }) {
  const { t } = useTranslation();
  return (
    <Container>
      <Img src={background} alt={t('Demande spéciale')} />
      <TextContainer>
        <Title>{t('Demande spéciale')}</Title>
        <Text>
          {t(
            'Pour toute demande urgente ou spécifique, nous vous invitons à envoyer un mail à',
          )}
          {' '}
          <ContactLink href={`mailto:${contactInfos.mail}`}>
            {contactInfos.mail}
          </ContactLink>
          {t(
            '. Nous ferons tout notre possible pour répondre à vos demandes selon la disponibilité et les expertises de nos Tillistes.',
          )}

        </Text>
      </TextContainer>
    </Container>
  );
}

SpecialRequest.propTypes = {
  background: PropTypes.string.isRequired,
};

export default SpecialRequest;
